export default __webpack_public_path__ + "static/media/pendingIcon.78d7c27e.svg";